import { fromJS } from "immutable";
import * as actionTypes from "../constants";

export const initialState = fromJS({
  id: null,
  addressView: null,
  personId: null,
  createDate: "",
  email: "",
  isFirmLocked: false,
  mustChangePassword: false,
  pinOverride: false,
  passwordExpireDate: "",
  isActive: true,
  firmId: null,
  firmName: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  imageUrl: "",
  hasAdminAccess: false,
  advisor: {
    advisorId: null,
    personId: null,
    isActive: true,
  },
  roles: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_CURRENT_USER_DATA:
      const hasAdmin = action.data.userRoles.includes("Admin");

      return state
        .setIn(["id"], action.data["userId"])
        .setIn(["personId"], action.data["personId"])
        .setIn(["email"], action.data["advisorEmail"])
        .setIn(["firmName"], action.data["firmName"])
        .setIn(["phoneNumber"], action.data["advisorPhoneNumber"])
        .setIn(["addressView"], action.data["addressView"])
        .setIn(["firmId"], action.data["firmId"])
        .setIn(["advisor", "advisorId"], action.data.advisorId)
        .setIn(["advisor", "personId"], action.data.personId)
        .setIn(["firstName"], action.data["firstName"])
        .setIn(["lastName"], action.data["lastName"])
        .setIn(["hasAdminAccess"], hasAdmin);
    case actionTypes.CLEAR_CURRENT_USER_DATA:
      return initialState;
    case actionTypes.SET_FIRM_ID:
      return state.setIn(["firmId"], action.firmId);
    case actionTypes.SET_CURRENT_USER_IMAGE:
      return state.setIn(["imageUrl"], action.data);
    default:
      return state;
  }
}
